export interface OutgrowerMonitoringQuestionnaire {
  id?: string;
  // Server doc identifier (when created remotely)
  remote_name?: string;
  // Metadata
  farm_visit_date?: string; // YYYY-MM-DD
  field_officer?: string;

  // Farmer Info
  farmer?: string;
  first_name?: string;
  last_name?: string;
  cluster?: string;

  // Farm Info
  latitude?: string;
  longitude?: string;
  farm_photo?: FileList | string;
  no_of_hectares?: string;
  package?: "Maize" | "Sorghum/Soya";
  crop_condition?: "Good" | "Bad";
  remarks?: string;
  are_you_satisfied_with_the_quality_of_input_disbursed?: "Yes" | "No";
  what_would_you_like_improvement_on?: string;

  // System fields
  status?: "pending" | "unsynced" | "partial-sync" | "synced";
  creation?: string;
  modified?: string;
}

export const OUTGROWER_MONITORING_SCHEMA =
  "id, farmer, farm_visit_date, field_officer, first_name, last_name, cluster, latitude, longitude, farm_photo, no_of_hectares, package, crop_condition, remarks, are_you_satisfied_with_the_quality_of_input_disbursed, what_would_you_like_improvement_on, status, creation, modified";
